<template>
  <div style="display: flex; flex-direction: row;">
    <div style="border-right: 1px solid #99a9bf; padding-right: 1rem; margin-right: 0.5rem">
      <el-tree ref="tree"
               :data="[processTree]"
               :default-expand-all="true"
               :expand-on-click-node="false"
               :highlight-current="true"
               node-key="label"
               @node-click="itemClick" />
    </div>
    <div style="flex: 1; overflow: auto">
      <img v-if="currentProcessInstance" :src="imgSrc" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiagramViewer',
  props: {
    showTree: {
      type: Boolean,
      default: true
    },
    processTree: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      currentProcessInstance: {},
    }
  },
  computed: {
    imgSrc () {
      return this.currentProcessInstance.id
        ? process.env.BASE_API + 'app/rest/bpm/pm/process-instance/' + this.currentProcessInstance.id + '/diagram'
        : ''
    }
  },
  watch: {
    processTree: {
      handler: function (newValue) {
        this.itemClick(newValue)
      },
      immediate: true
    }
  },
  methods: {
    itemClick (item) {
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(item.label)
      })
      this.currentProcessInstance = item.processInstance
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bpm/DiagramViewer.vue